const standardFeatures = [
  '360 Camera',
  'Adaptive Cruise Control',
  'Android Auto',
  'Apple Carplay',
  'Automatic Emergency Braking',
  'Automatic Self Parking',
  'Blindspot Sensors',
  'Bluetooth Music',
  'Cooled Seats',
  'DVD Video',
  'Fold Down Rear Seats',
  'GPS Navigation',
  'Hands Free Calling',
  'Heads Up Display',
  'Heated Mirrors',
  'Heated Seats',
  'Heated Steering Wheel',
  'Home Link',
  'Keyless Ignition',
  'Lane Departure Warning',
  'Leather Interior',
  'Park Assist',
  'Power Adjustable Pedals',
  'Power Mirrors',
  'Power Passenger Seat',
  'Power Sliding Doors',
  'Power Tailgate Hatch',
  'Premium Sound',
  'Rear Seat Entertainment',
  'Rear View Camera',
  'Remote Start',
  'Satellite Radio',
  'Sunroof',
  'Third Row Seat',
  'Tilt Wheel',
  'Tow Hitch',
  'Trailer Brake Controller',
  'Trailer Towing Connector',
  'USB Input',
  'Wi Fi Hotspot',
  'Xenon/HID/LED Headlamps/Taillamps'
];

export default standardFeatures;
